import { render, staticRenderFns } from "./AddLabResultsModal.vue?vue&type=template&id=5cc79ac1&"
import script from "./AddLabResultsModal.vue?vue&type=script&lang=js&"
export * from "./AddLabResultsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports